// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 752) return "static/chunks/752-8bbb3213954d01ff.js";
	if (chunkId === 525) return "static/chunks/525-81a2a1948c76715a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"218":"89470a8d2ecce0a6","467":"c4dfcea41c679e5d","521":"b766ef233d6cc968","964":"d602607b7a7a70bc"}[chunkId] + ".js";
};